import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import OlMap from 'ol/map';
import Tile from 'ol/layer/tile';
import TileImage from 'ol/source/tileimage';
import control from 'ol/control';
import Projection from 'ol/proj/projection';
import View from 'ol/view';
import styled from 'styled-components';
import Extent from 'ol/extent';
import TileGrid from 'ol/tilegrid/tilegrid';
import PhotoFaultsLayer from './PhotoFaultsLayer';
import { getSelectInteractionManager } from './../../../../../utilities/selectInteractionManager';

const StyledWrapper = styled.div`
    background-color: #ffffff;
    height: 100%;
    .ol-zoom {
        top: 39px;
        left: 2px;
        background-color: unset;
        :hover{
            background-color: unset;
        }
        button{ 
            width: 34px;
            height: 34px;
            background-color: #265a9c;
            box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
            cursor: pointer;
            :hover{
                box-shadow: 0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23);
                background-color: #6b95bc;
            }
        }
    }
`;

const ShadowBox = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.75);
`;

// IMAGE_MAP_WIDTH and IMAGE_MAP_HEIGHT must be divisible TILE_SIZE 
const TILE_SIZE = 256;
const IMAGE_MAP_WIDTH = 1024;
const IMAGE_MAP_HEIGHT = 1024;

class TiledImageMap extends React.Component {
    tiledImageMap = null;
    tiledImageMapNode = null;

    constructor(props) {
        super(props);
        const { resizeObservable } = props;

        const projection = new Projection({
            code: '',
            units: 'tile-pixels',
            global: false,
            extent: [0, 0, IMAGE_MAP_WIDTH, IMAGE_MAP_HEIGHT],
        });

        this.tiledImageMap = new OlMap({
            controls: control.defaults(),
            preload: 1,
            view: new View({
                projection,
                zoom: 2,
                zoomFactor: 2
            }),
            renderer: "canvas",
        });

        resizeObservable.subscribe(() => {
            this.tiledImageMap.updateSize();
        });

        getSelectInteractionManager('tiles').createSelectInteraction(this.tiledImageMap);
    }

    updateTileImageMap = () => {
        const { imageWidth, imageHeight, url, maxZoom } = this.props;
        const layerExtentWidth = 1.0 * imageWidth / (TILE_SIZE * Math.pow(2, maxZoom)) * IMAGE_MAP_WIDTH;
        const layerExtentHeight = 1.0 * imageHeight / (TILE_SIZE * Math.pow(2, maxZoom)) * IMAGE_MAP_HEIGHT;
        const layerExtent = [0, 0, layerExtentWidth, layerExtentHeight];
        const resolutions = [];
        for (let i = 0; i <= maxZoom; i++) {
            resolutions.push(IMAGE_MAP_WIDTH / TILE_SIZE / Math.pow(2, i));
        }

        this.tiledImageMap.removeLayer(this.tileLayer);

        this.tileLayer = new Tile({
            source: new TileImage({
                tileUrlFunction: (tileCoord, pixelRatio, projection) => {
                    const zoom = tileCoord[0];
                    //TODO: wymyślić lepsze rozwiązanie
                    // istnieje bug, jeżeli szybko zbliżymy do maksymalnego zooma
                    // kafle nie zostaną wczytane
                    // może przełącznik zezwalający?
                    if (zoom > maxZoom) return false;

                    const xCoord = tileCoord[1];
                    const yCoord = -tileCoord[2] - 1;

                    const token = localStorage.getItem('token');
                    return `${url}/${zoom}/${yCoord}/${xCoord}?token=${token}`;
                },
                transition: 0,
                // https://openlayers.org/en/latest/apidoc/ol.tilegrid.TileGrid.html
                tileGrid: new TileGrid({
                    extent: layerExtent,
                    origin: [0, layerExtentHeight],
                    resolutions: resolutions,
                    tileSize: [TILE_SIZE, TILE_SIZE]
                })
            })
        });
        this.tiledImageMap.addLayer(this.tileLayer);

        const view = this.tiledImageMap.getView();
        view.setCenter(Extent.getCenter(layerExtent));
        view.setZoom(Math.log2(IMAGE_MAP_WIDTH / TILE_SIZE));
        // view.setMaxZoom(maxZoom);
    }

    componentDidMount() {
        this.tiledImageMap.setTarget(this.tiledImageMapNode);
        this.updateTileImageMap();
    }

    componentWillUnmount() {
        getSelectInteractionManager('tiles').removeSelectInteraction(this.tiledImageMap);
    }

    componentDidUpdate(prevProps) {
        if (this.props.url !== prevProps.url) {
            this.updateTileImageMap();
        }
    }

    render() {
        return (
            <StyledWrapper className='TiledImageMap' innerRef={node => { this.tiledImageMapNode = node }}>
                <PhotoFaultsLayer olMap={this.tiledImageMap} />
                <ShadowBox />
            </StyledWrapper>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TiledImageMap);


// WEBPACK FOOTER //
// ./src/containers/content/grid/tilesGalleryWrapper/tiledImageMap/TiledImageMap.jsx